import { render, staticRenderFns } from "./ConferenceManageView.vue?vue&type=template&id=8746e954&scoped=true&"
import script from "./ConferenceManageView.vue?vue&type=script&lang=js&"
export * from "./ConferenceManageView.vue?vue&type=script&lang=js&"
import style0 from "./ConferenceManageView.vue?vue&type=style&index=0&id=8746e954&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8746e954",
  null
  
)

export default component.exports